import axios from "axios";

// 統一的後端網址來源：原本每個頁面各自宣告一份
// `const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://bindlab.cgu.edu.tw";`，
// 改成整個 managerui 只有這裡有一份，其他地方一律 import 這個常數。
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://bindlab.cgu.edu.tw";

// 共用的 axios instance：已經帶 baseURL，呼叫端只要寫路徑本身
// （例如 `apiClient.get("/api/playlists")`），不用每次自己組字串。
// 保留匯出 axios 本身，讓還沒遷移用法的呼叫點可以繼續用
// `axios.get(`${API_BASE_URL}/...`)` 這種舊寫法，兩種寫法可以並存。
const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

export default apiClient;
